<lib-prod-form [fields]="fields" [data]="data" (onSubmitEvent)="submit($event)" [style]="style"></lib-prod-form>
